import { useTranslation } from 'react-i18next';
import type { ActionPreview } from '@nexus/ai';
import type { Describe } from './chat';

/** The activity-log line for an action, in the app's language. */
export function useDescribe(): Describe {
  const { t } = useTranslation();
  return (p: ActionPreview) =>
    t(`ai.actions.log.${p.action}`, {
      title: p.title,
      where: p.details.find((d) => d.label === 'where' || d.label === 'to')?.value ?? '',
    });
}
